import React, { useState, useEffect } from 'react'
import { Row, Col, Form, TimePicker } from 'antd'
import moment, { Moment } from 'moment'
import Modal from 'antd/lib/modal/Modal'
import Calendar from 'react-calendar'
import '../../../../CreateEvent/Screens/GeneralDetails/styles/general-details.scss'
import { DeleteOutlined } from '@ant-design/icons'
import { PlusCircle } from '@phosphor-icons/react'
import { classesEventStore } from 'state/classes/classesStore'
import {
  convertMinutesToLocalTime,
} from 'helper/utility'
import { SpecialSchedule } from 'types/globalTypes'
import { TicketsResp } from 'types/event/eventStep4'

const SelectMultiDaysCalenderModel = ({
  setSpecialScheduleVisible,
  setIsSelectMultiDaysCalenderVisible,
  selectedDates,
  setSelectedDates,
  setEventTime,
  specialScheduleData,
  setSpecialScheduleData,
  step1,
  type,
  allowedTicketId,
  defaultTime,
  setDefaultTime,
}: any) => {
  const classesData = classesEventStore(store => store.classesData)
  const [form] = Form.useForm()
  const [eventDates, setEventDates] = useState<Date[]>([])
  const [activeStartDate, setActiveStartDate] = useState<Date>(new Date())

  const handleStartTimeChange = (time: Moment | null, timeString: string) => {
    const newStartTime = moment(time)
    setDefaultTime({ ...defaultTime, startTime: newStartTime })
  }

  const handleEndTimeChange = (time: Moment | null, timeString: string) => {
    const newEndTime = moment(time)
    setDefaultTime({ ...defaultTime, endTime: newEndTime })
  }

  const handleTileClick = (date: any) => {
    const formattedDate = moment(date).format('YYYY-MM-DD')
    if (!selectedDates?.includes(formattedDate)) {
      if (selectedDates) {
        setSelectedDates([...selectedDates, formattedDate])
      } else {
        setSelectedDates([formattedDate])
      }
    } else {
      setSelectedDates(
        selectedDates.filter(
          (selectedDate: any) => selectedDate !== formattedDate,
        ),
      )
    }
  }

  const getSelectableDatesInMonth = (monthDate: Date, minDateObj?: Date) => {
    const year = monthDate.getFullYear()
    const month = monthDate.getMonth()
    const first = new Date(year, month, 1)
    const last = new Date(year, month + 1, 0)
    const dates: string[] = []

    const rawMinObj =
      minDateObj ||
      (step1
        ? new Date()
        : eventDates && eventDates.length
        ? new Date(eventDates[0])
        : new Date())
    const minObj = new Date(rawMinObj)
    minObj.setHours(0, 0, 0, 0)

    for (let d = new Date(first); d <= last; d.setDate(d.getDate() + 1)) {
      const copy = new Date(d)
      const isWithinEvents =
        step1 ||
        eventDates.some(
          eventDate =>
            eventDate.getDate() === copy.getDate() &&
            eventDate.getMonth() === copy.getMonth(),
        )

      if (isWithinEvents && copy.getTime() >= minObj.getTime()) {
        dates.push(moment(copy).format('YYYY-MM-DD'))
      }
    }

    return dates
  }

  const handleSelectAllDays = () => {
    const month = activeStartDate || new Date()
    const rawMinDateObj =
      step1 || !eventDates.length ? new Date() : new Date(eventDates[0])
    const minDateObj = new Date(rawMinDateObj)
    minDateObj.setHours(0, 0, 0, 0)

    const monthDates = getSelectableDatesInMonth(month, minDateObj)
    if (monthDates.length === 0) return

    const allSelected = monthDates.every(d => selectedDates?.includes(d))
    if (allSelected) {
      setSelectedDates(selectedDates.filter((sd: string) => !monthDates.includes(sd)))
    } else {
      setSelectedDates(
        Array.from(
          new Set([...(selectedDates || []), ...monthDates]),
        ),
      )
    }
  }

  const handleSelectWeekdays = () => {
    const month = activeStartDate || new Date()
    const year = month.getFullYear()
    const monthIndex = month.getMonth()
    const first = new Date(year, monthIndex, 1)
    const last = new Date(year, monthIndex + 1, 0)
    const weekdayDates: string[] = []
    const weekendDates: string[] = []
    const rawMinDateObj =
      step1 || !eventDates.length ? new Date() : new Date(eventDates[0])
    const minDateObj = new Date(rawMinDateObj)
    minDateObj.setHours(0, 0, 0, 0)

    for (let d = new Date(first); d <= last; d.setDate(d.getDate() + 1)) {
      const copy = new Date(d)
      const day = copy.getDay()
      const isWeekday = day !== 0 && day !== 6
      const formattedDate = moment(copy).format('YYYY-MM-DD')

      const isWithinEvents =
        step1 ||
        eventDates.some(
          eventDate =>
            eventDate.getDate() === copy.getDate() &&
            eventDate.getMonth() === copy.getMonth(),
        )

      if (isWithinEvents && copy.getTime() >= minDateObj.getTime()) {
        if (isWeekday) {
          weekdayDates.push(formattedDate)
        } else {
          weekendDates.push(formattedDate)
        }
      }
    }

    if (weekdayDates.length === 0) return

    const allWeekdaysSelected = weekdayDates.every(
      d => selectedDates?.includes(d),
    )
    const anyWeekendSelected = weekendDates.some(
      d => selectedDates?.includes(d),
    )

    // Only toggle weekdays OFF when the selection is already weekdays-only
    // (a second click to clear). If any weekend is selected — e.g. right after
    // "All days of month" — treat this as "select weekdays only" instead, so we
    // don't strip the weekdays and leave the weekends behind.
    if (allWeekdaysSelected && !anyWeekendSelected) {
      setSelectedDates(
        selectedDates.filter((sd: string) => !weekdayDates.includes(sd)),
      )
    } else {
      const filteredDates = selectedDates.filter(
        (sd: string) => !weekendDates.includes(sd),
      )
      setSelectedDates(Array.from(new Set([...filteredDates, ...weekdayDates])))
    }
  }

  const removeSpecialscheduleInput = (index: number) => {
    const current: any = specialScheduleData[index]
    setSpecialScheduleData([
      ...specialScheduleData.filter((data: any) => data.day !== current.day),
    ])
  }

  const onAddPress = (values: any) => {
    setIsSelectMultiDaysCalenderVisible(false)
  }

  useEffect(() => {
    setEventTime(defaultTime)
  }, [defaultTime])

  useEffect(() => {
    if (type === 'admission') {
      const locallyConvertedDate = []
      classesData?.datesOfEvent?.map((date: string) => {
        const utcDate = new Date(date)
        utcDate.setMinutes(utcDate.getMinutes() + utcDate.getTimezoneOffset())
        locallyConvertedDate.push(utcDate)
      })
      setEventDates(locallyConvertedDate)
    } else if (type === 'additional') {
      const locallyConvertedDate = []
      const selectedAdmissionTicket = classesData.admissionTickets?.find(
        (ticket: TicketsResp) => ticket._id === allowedTicketId,
      )
      selectedAdmissionTicket?.days?.map(date => {
        const utcDate = new Date(date)
        utcDate.setMinutes(utcDate.getMinutes() + utcDate.getTimezoneOffset())
        locallyConvertedDate.push(utcDate)
      })
      setEventDates(locallyConvertedDate)
    }
  }, [classesData])

  return (
    <div>
      <Modal
        open={true}
        className="map-modal add-more-fees-modal"
        footer={null}
        centered={true}
        width={450}
        onCancel={() => {
          setIsSelectMultiDaysCalenderVisible(false)
        }}
      >
        <h1 className="text-center text-24px w1"> Select Event Days </h1>
        <Form
          className="-mt-20px"
          form={form}
          layout="horizontal"
          onFinish={onAddPress}
        >
          <div className="h-30rem overflow-auto-y scroller pb-20px">
            <div className="event-days-calendar">
              <Row style={{ marginTop: 50 }}>
                <Col>
                  <Form.Item name="date">
                    {step1 ? (
                      <Calendar
                        calendarType="US"
                        minDate={new Date()}
                        onClickDay={handleTileClick}
                        onActiveStartDateChange={({ activeStartDate }) =>
                          setActiveStartDate(activeStartDate)
                        }
                        tileClassName={({ date, view }) => {
                          if (
                            selectedDates?.find(
                              (x: any) =>
                                x === moment(date).format('YYYY-MM-DD'),
                            )
                          ) {
                            return 'selected'
                          }
                        }}
                      />
                    ) : (
                      <Calendar
                        calendarType="US"
                        minDate={
                          eventDates &&
                          moment(eventDates[0], 'YYYY-MM-DD').toDate()
                        }
                        defaultActiveStartDate={
                          eventDates.length &&
                          moment(eventDates[0], 'YYYY-MM-DD').toDate()
                        }
                        onClickDay={handleTileClick}
                        onActiveStartDateChange={({ activeStartDate }) =>
                          setActiveStartDate(activeStartDate)
                        }
                        tileClassName={({ date, view }) => {
                          if (
                            selectedDates?.find(
                              (x: any) =>
                                x === moment(date).format('YYYY-MM-DD'),
                            )
                          ) {
                            return 'selected'
                          }
                        }}
                        maxDate={
                          eventDates &&
                          moment(
                            eventDates[eventDates.length - 1],
                            'YYYY-MM-DD',
                          ).toDate()
                        }
                        tileDisabled={({ date }) =>
                          !eventDates.some(
                            eventDate =>
                              eventDate.getDate() === date.getDate() &&
                              eventDate.getMonth() === date.getMonth(),
                          )
                        }
                      />
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <div className="mt-15px w-full flex justify-center gap-10px">
              <button
                className="btn-secondary"
                type="button"
                onClick={handleSelectAllDays}
              >
                All days of month
              </button>
              <button
                className="btn-secondary"
                type="button"
                onClick={handleSelectWeekdays}
              >
                All weekdays of month
              </button>
            </div>

            <div>
              <h2 className="text-14 w-600">Weekly default schedule</h2>
              <div className="flex align-center gap-16px mt-15px w-80p">
                <TimePicker
                  className="w-100 form-control-field"
                  placeholder="Start Time"
                  format="h:mm a"
                  value={defaultTime.startTime}
                  showNow={false}
                  clearIcon={false}
                  onChange={handleStartTimeChange}
                />
                <div>-</div>
                <TimePicker
                  className="w-100 form-control-field"
                  placeholder="End Time"
                  format="h:mm a"
                  value={defaultTime.endTime}
                  showNow={false}
                  clearIcon={false}
                  onChange={handleEndTimeChange}
                />
              </div>
            </div>

            <div className="flex align-center justify-between gap-16px mt-20px">
              <h2 className="text-14 w-600">Add special schedule</h2>
              <PlusCircle
                className="pointer"
                size={20}
                color="#000"
                onClick={() => setSpecialScheduleVisible(true)}
              />
            </div>

            {specialScheduleData.length > 0 && (
              <div className="mt-20px">
                <div>
                  {specialScheduleData.map(
                    (specialSchedule: SpecialSchedule, index: number) => {
                      return (
                        <div className="mt-10px" key={index}>
                          <h4 className="text-14 w-600">
                            {/* {specialSchedule.day} */}
                            {moment(specialSchedule.day).format('DD-MM-YYYY')}
                          </h4>
                          <div>
                            <div className="flex justify-between align-center w-full">
                              <div className="flex align-center gap-16px mt-15px">
                                <TimePicker
                                  className="w-100 form-control-field"
                                  placeholder="Start Time"
                                  format="h:mm a"
                                  showNow={false}
                                  clearIcon={false}
                                  value={moment(
                                    convertMinutesToLocalTime(
                                      specialSchedule.startTime,
                                    ),
                                    'hh:mm A',
                                  )}
                                  onChange={handleStartTimeChange}
                                  disabled
                                />
                                <div>-</div>
                                <TimePicker
                                  className="w-100 form-control-field"
                                  placeholder="End Time"
                                  format="h:mm a"
                                  showNow={false}
                                  clearIcon={false}
                                  value={moment(
                                    convertMinutesToLocalTime(
                                      specialSchedule.endTime,
                                    ),
                                    'hh:mm A',
                                  )}
                                  onChange={handleEndTimeChange}
                                  disabled
                                />
                              </div>

                              <DeleteOutlined
                                onClick={() =>
                                  removeSpecialscheduleInput(index)
                                }
                                style={{
                                  color: '#FF6961',
                                  paddingLeft: '5px',
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )
                    },
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="flex justify-center align-center gap-16px mt-15px">
            <button
              className="btn-gray br-8"
              onClick={() => setIsSelectMultiDaysCalenderVisible(false)}
            >
              Cancel
            </button>
            <button className="prim-btn cursor-pointer" type="submit">
              Save
            </button>
          </div>
        </Form>
      </Modal>
    </div>
  )
}
export default SelectMultiDaysCalenderModel
